document.addEventListener('DOMContentLoaded', function () {
  const main = document.querySelector('main.publications')
  if (!main || typeof publicationsAjax === 'undefined') return

  const archive = main.querySelector('.js_publications_archive')
  const tabButtons = main.querySelectorAll('.js_publications_tab')
  const result = main.querySelector('.js_publications_result')
  const titles = main.querySelectorAll('.js_publications_title')
  if (!archive || !result) return

  const setLoading = (loading) => archive.classList.toggle('is-loading', loading)

  function scrollToPublicationsSection() {
    const section = main.querySelector('.sec02')
    if (!section) return

    const header = document.querySelector('header')
    const headerHeight = header ? header.offsetHeight : 0
    const top = window.pageYOffset + section.getBoundingClientRect().top - headerHeight

    window.scrollTo({ top, behavior: 'smooth' })
  }

  async function fetchPublications(term, paged = 1) {
    const formData = new FormData()
    formData.append('action', publicationsAjax.action)
    formData.append('term', term)
    formData.append('paged', paged)
    formData.append('lang', archive.dataset.lang || '')
    setLoading(true)

    try {
      const response = await fetch(publicationsAjax.ajax_url, { method: 'POST', body: formData })
      const json = await response.json()
      if (!json.success || !json.data) return

      archive.dataset.term = json.data.term
      archive.dataset.paged = json.data.paged
      tabButtons.forEach((button) =>
        button.classList.toggle('is-current', button.dataset.term === json.data.term),
      )
      titles.forEach((title) => {
        title.textContent = json.data.term_label
      })
      result.innerHTML = json.data.list_html
      scrollToPublicationsSection()
    } catch (error) {
      console.error('Publications ajax error:', error)
    } finally {
      setLoading(false)
    }
  }

  tabButtons.forEach((button) => {
    button.addEventListener('click', () => {
      if (button.dataset.term) fetchPublications(button.dataset.term)
    })
  })

  result.addEventListener('click', (event) => {
    const paginationLink = event.target.closest('.pagination a[data-paged]')
    if (!paginationLink) return

    event.preventDefault()
    fetchPublications(archive.dataset.term, paginationLink.dataset.paged)
  })
})
